<div class="widget">
  <div class="amSuite-widget-header">
    {{'widgets.activity-graphs.hour-graph.title' | translate}}
    @if (modify) {
      <a href="javascript:void(0)" (click)="actpop()" class="modify-btn"
        pTooltip="{{'widgets.user-activities.edit' | translate}}">
        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
      </a>
    }
    @if (!modify) {
      <small class="date-font"><i>({{ initialDate | dateMoment:shortDate }} -
        {{ finalDate | dateMoment:shortDate }})</i></small>
    }
  </div>
  <div class="graph-widget amSuite-widget-block height-auto" style="overflow-y: hidden;">
    @switch (status) {
      @case ('ready') {
        <div class="chart-card-content">
          <div class="time-sheet-content">
            <div class="progress-ring">
              <svg viewBox="0 0 120 120">
                <defs>
                  <linearGradient id="hourRingGrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stop-color="#F6A14C" />
                    <stop offset="100%" stop-color="#C9650F" />
                  </linearGradient>
                </defs>
                <circle class="progress-background" cx="60" cy="60" r="52"></circle>
                <circle class="progress-fill" cx="60" cy="60" r="52"
                  [style.stroke-dasharray]="(totalActivityTimeSum > 0 ? (workedActivityTimeSum / totalActivityTimeSum * 327) : 0) + ' 327'">
                </circle>
              </svg>
              <div class="progress-text">
                <span class="progress-value">
                  {{ (totalActivityTimeSum > 0 ? (workedActivityTimeSum / totalActivityTimeSum * 100) : 0) | number:'1.0-1' }}%
                </span>
                <span class="progress-cap">{{ 'widgets.activity-graphs.hour-graph.completed' | translate }}</span>
              </div>
            </div>
            <div class="time-row">
              <div class="time-card accent">
                <div class="v">{{ workedActivityTimeSum | number:'1.0' }}</div>
                <span class="l">{{ 'widgets.activity-graphs.hour-graph.worked' | translate }}</span>
              </div>
              <div class="time-card">
                <div class="v">{{ totalActivityTimeSum | number:'1.0' }}</div>
                <span class="l">{{ 'widgets.activity-graphs.hour-graph.total' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      }
      @case ('busy') {
        <div style="display: flex; justify-content: center; align-items: center; min-height: 200px;">
          <p-progressSpinner strokeWidth="3" animationDuration="1s"></p-progressSpinner>
        </div>
      }
    }
  </div>
</div>
